import api from '@/api';
import { message } from "antd";
import moment from 'moment';



const initialState = {
	pending: false,
	showSendingModal: false,
	sendingModalMessages: [],
	showApprovalModal: false,
	approvalModalRowID: null,
	loading: false,
	loadingDetails: false,
	lastOpen: null,
	documents: [],
	rowDetailData: [],
	rowPODetailData: [],
	approvalPending: false,
	searchStrings: {
		approver: '',
		decision: '',
		vendor: '',
		jobID: '',
		docNum: '',
		dateFrom: moment().subtract(3, 'months').format('YYYY-MM-DD'),
		dateTo: moment().format('YYYY-MM-DD'),
	},
};


export const types = {
	SET_STATE: 'APPROVALSREVIEW/SET_STATE',
};




export const reducers = (state = initialState, action) => {
	switch(action.type) {
		case types.SET_STATE:
			return { ...state, ...action.data };
		default:
			return state;
	}
}

export default reducers;



export const actions = {
	setState: (data) => ({ type: types.SET_STATE, data }),




	resetApprovals: () => ({
		type: types.SET_STATE,
		data: { ...initialState },
	}),




	resetApprovalModal: () => (dispatch, getState) => ({
		type: types.SET_STATE, data: {
			showApprovalModal: false,
			approvalModalRowID: null,
			approvalPending: false, initialState,

		},
	}),




	updateSearchString: (key, value) => (dispatch, getState) => {
		let strings = {
			...getState().approvalsReview.searchStrings,
			[ key ]: value,
		};

		dispatch(actions.setState({
			searchStrings: strings,
		}));
	},



	loadDocuments: () => async (dispatch, getState) => {
		dispatch(actions.setState({
			loading: true,
			documents: [],
		}));

		try {
			let response = await api.get(`/approvals/review`, {
				timeout: 60000,
				params: getState().approvalsReview.searchStrings,
			});
			dispatch({
				type: types.SET_STATE,
				data: {
					loading: false,
					documents: response.documents,
				},
			});
		} catch(err) {
			dispatch({
				type: types.SET_STATE,
				data: {
					loading: false,
				},
			});
		}

	},

	getRowDetail: (rowID) => async (dispatch, getState) => {
		let rowDetailData = getState().approvalsReview.rowDetailData;

		// Already loaded
		if(rowDetailData[ rowID ] !== undefined) {
			return true;
		}


		dispatch({
			type: types.SET_STATE,
			data: {
				lastOpen: rowID,
				loadingDetails: true,
			},
		});


		try {
			let rows = await api.get(`/approvals/review/details/${rowID}`, { timeout: 60000 });
			//console.log(response)
			let newDetails = [ ...rowDetailData ];
			newDetails[ rowID ] = rows.details;

			dispatch({
				type: types.SET_STATE,
				data: {
					rowDetailData: newDetails,
					loadingDetails: false,
				},
			});

		} catch(err) {
			console.error(err);
			dispatch({
				type: types.SET_STATE,
				data: {
					loadingDetails: false,
				},
			});
		}
	},


};